import { useLayoutEffect } from 'react'
import { useSceneStore } from '@editor/stores'
import { useColoringWidgetMapping } from '@editorHooks'

const useSceneColoring = (enabled = true) => {
  const coloringWidgetMapping = useColoringWidgetMapping()

  const setGuidToColorMapping = useSceneStore(state => state.setGuidToColorMapping)
  const clearGuidToColorMapping = useSceneStore(state => state.clearGuidToColorMapping)

  useLayoutEffect(() => {
    if (!enabled) return

    if (coloringWidgetMapping) setGuidToColorMapping(coloringWidgetMapping)

    return () => clearGuidToColorMapping()
  }, [coloringWidgetMapping, enabled, setGuidToColorMapping, clearGuidToColorMapping])
}

export default useSceneColoring
